export enum LoginCodeStatus {
    pending = "c1a2b3c4-d5e6-4f78-9a0b-1c2d3e4f5a6b",
    verified = "d2b3c4d5-e6f7-4a89-0b1c-2d3e4f5a6b7c",
    expired = "e3c4d5e6-f7a8-4b90-1c2d-3e4f5a6b7c8d",
    failed = "f4d5e6f7-a8b9-4c01-2d3e-4f5a6b7c8d9e",
}

export enum AuthTokenStatus {
    active = "e1dd2e9a-ee93-40b0-a09e-c614107dfecc",
    revoked = "dde2f6ed-64b3-4a72-bebe-dde89834ad51",
    expired = "e8b5f72b-1e94-4701-8e52-bdcc17fcd775",
}

export enum LoginMethod {
    email = "d4e8f1a2-3b5c-4d6e-8f9a-0b1c2d3e4f5a",
    phone = "e5f9a2b3-4c6d-5e7f-9a0b-1c2d3e4f5a6b",
}

export enum AuthTokenType {
    access = "f1a2b3c4-5d6e-4f78-9a0b-1c2d3e4f5a6b",
}
